import { Pipe, PipeTransform, Input } from '@angular/core';
import { AuthService } from '../services/auth.service';
import * as _ from 'lodash';
import { normalizeCaseAndAccents } from '../utils/functions';
import moment from 'moment';
import { DateService } from '../services/date.service';
import levenshtein from 'js-levenshtein';

const MIN_FILTER_SIZE = 3

@Pipe({ name: 'generalFilter' })
export class GeneralFilterPipe implements PipeTransform {

    constructor(private dateService: DateService) {

    }

    transform(items, filterValue) {
        if (_.size(filterValue) >= MIN_FILTER_SIZE) {
            return _.filter(items, (i) => {
                return this.matchItem(i, filterValue);
            })
        } else {
            return items;
        }
    }

    matchItem(item, filterValue) {
        return _.some(_.keysIn(item), (k) => {
            return this.matchValue(item[k], k, filterValue);
        })
    }


    matchValue(value, key, filterValue) {
        if (this.isSupportedValue(value)) {
            if (_.isBoolean(value)) {
                return this.matchBoolean(value, key, filterValue)
            } else if (moment.isDate(value)) {
                return this.matchDate(value,filterValue);
            } if (_.isObject(value)) {
                return this.matchItem(value, filterValue)
            } else {
                return this.match(value,filterValue)
            }
        } else {
            return false;
        }
    }

    isSupportedValue(value) {
        return value;
    }

    matchDate(value,filterValue){
        return this.match(this.dateService.formatDate(value),filterValue);
    }

    matchBoolean(value, key, filterValue) {
        let splittedKey = _.split(key, '_');
        return _.some(splittedKey, (k) => {
            return levenshtein(normalizeCaseAndAccents(k), normalizeCaseAndAccents(filterValue)) <= 3;
        })
    }

    match(value1,value2){
        return _.includes(normalizeCaseAndAccents(value1), normalizeCaseAndAccents(value2));
    }
}